import styled from 'styled-components';

export const TimeText = styled.div`
  font-size: 5em;
  font-weight: bold;
`;

export const DateText = styled.div`
  font-size: 1.25em;
  font-weight: bold;
`;

export const MenuModalItemIcon = styled.div`
  text-align: ${() => ('center')};
  font-size: 80px;
  color: ${(props) => (props.active ? props.theme.colors.iconActive : props.theme.colors.iconInactive)};
`;

export const MainButton = styled.div`
  background: ${(props) => (props.active ? props.theme.colors.buttonPrimary : props.theme.colors.buttonSecondary)};
  color: ${(props) => (props.active ? props.theme.colors.textActive : props.theme.colors.textInactive)};
  border: none;
  padding: 20px;
  border-radius: 20px;
  min-width: 175px;
  min-height: 175px;
  max-width: 175px;
  max-height: 175px;
  font-size: 20px;
  cursor: pointer;
  /* box-shadow removed for TV performance */
  transition: all 0.25s ease-out; /* Added for consistent button transitions */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;

  > div {
    margin-bottom: 5px;
  }
    
  &:hover {
    background: ${(props) => props.theme.colors.buttonPrimary};
    color: ${(props) => props.theme.colors.textActive};

    ${MenuModalItemIcon} {
      color: ${(props) => props.theme.colors.iconActive};
    }
  }
  &:focus-visible {
    outline: none;
  }
  ${({ active }) => active && `
    ${MenuModalItemIcon} {
      color: ${(props) => props.theme.colors.iconActive};
    }
  `}
`